export const SHOPPINGCART = 'SHOPPINGCART';
export const ADDRESS = 'ADDRESS';
export const USER = 'USER'; // 当前登录用户
export const ORDER = 'ORDER';
export const PREORDER = 'PREORDER';
export const USERS = 'USERS'; // 注册用户（多个）
export const TOKEN = 'TOKEN'; // token
export const MERCHANT = 'MERCHANT' // 商户



// WEBPACK FOOTER //
// ./src/const/localStorage.js